/* eslint-disable eag/match-named-export */
import {z} from '@hono/zod-openapi';

export const readAllConversationEventsParams = z.object({
  conversationId: z.string().uuid().openapi({
    description: 'ID of the conversation',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
});

export type ReadAllConversationEventsParams = z.infer<typeof readAllConversationEventsParams>;
